import React from 'react'
import {
  Checkbox as ChakraCheckbox,
  CheckboxProps,
  ThemingProps
} from '@chakra-ui/react'
import { css } from '@emotion/react'
import { isIE } from 'shared/helpers'

export const Checkbox = (
  props: CheckboxProps & {
    colorScheme?: ThemingProps['colorScheme']
  } & { partial?: boolean }
) => {
  return (
    <ChakraCheckbox
      data-test="Checkbox"
      icon={props.icon ? props.icon : <></>} // Hack will hide default icon of Checkbox
      css={
        isIE
          ? css`
              input {
                width: auto !important;
                height: auto !important;
                clip: auto !important;
                position: static !important;
              }
              .chakra-checkbox__control {
                display: none !important;
              }
            `
          : props.partial
          ? css`
              .chakra-checkbox__control {
                background: var(--chakra-colors-buttonPrimary-500);
                border-color: var(--chakra-colors-buttonPrimary-500);
              }
              .chakra-checkbox__control:before {
                position: absolute;
                height: 1px;
                width: 8px;
                background: #fff;
                left: 4px;
                top: 7px;
                content: '';
              }
            `
          : undefined
      }
      {...props}
    />
  )
}
